import Highcharts from 'plugins/highcharts/highcharts';
import { formatNumber } from '@/utils';

export const getPointWrapper = (coordinate) => {
  const coordinateType = coordinate.series.userOptions.type;
  const coordinateColor = coordinate.color;
  const coordinateSeriesName = coordinate.series.name;
  const coordinateYFormatted = formatNumber(coordinate.y);

  return `
  <div class="highcharts-custom-tooltip__item-wrapper">

    <div class="highcharts-custom-tooltip__item">
      <div class="highcharts-custom-tooltip__${coordinateType === 'spline' ? 'spline' : 'column'}"   
        style="color:${coordinateColor};"
      >
        <span>${coordinateSeriesName}</span>
      </div>
    </div>

    <div class="highcharts-custom-tooltip__variation">
      ${coordinateYFormatted}
    </div>

  </div>
  `;
};

const getPointList = (pointList) => {
  let pointsWrapper = '';

  pointList.forEach((point) => {
    pointsWrapper += getPointWrapper(point);
  });

  return pointsWrapper;
};

export const formatterTooltip = (coordinate, categorie) => {
  return `
  <div class="highcharts-custom-tooltip"> 
  
    <div class="highcharts-custom-tooltip__header">${categorie}</div>
  
    <div class="highcharts-custom-tooltip__content">
      ${getPointList(coordinate.points)}
    </div>
  
  </div>
  `;
};

export const formatterDateLabel = (date) => Highcharts.dateFormat('%d/%m', date);
